import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

const network = [
  "KeralaHealth.com",
  "Kerala.com",
  "Indias.com",
  "NaturePulse.net",
  "FoodPulse.net",
  "SocialPulse.com",
];

export default function Footer() {
  return (
    <footer className="mt-24 bg-brand-deep text-brand-sand/90">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="grid h-11 w-11 place-items-center rounded-full bg-brand-sand text-brand">
              <Leaf className="h-6 w-6" strokeWidth={1.75} />
            </span>
            <span className="font-heading font-bold text-3xl text-brand-sand">Ayurvedam<span className="text-brand-clay">.com</span></span>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-brand-sand/70">
            An independent Ayurveda authority. Reviewed, referenced educational content on therapies,
            herbs and traditional wellness — the canonical source for the SocialPulse network.
          </p>
          <p className="mt-6 text-xs text-brand-sand/50">
            Educational content only. Not a substitute for professional medical advice.
          </p>
        </div>
        <div>
          <h4 className="font-heading text-lg text-brand-sand">Explore</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-brand-sand/70">
            <li><Link to="/articles" className="hover:text-white transition-colors">Articles</Link></li>
            <li><Link to="/therapies" className="hover:text-white transition-colors">Therapies</Link></li>
            <li><Link to="/herbs" className="hover:text-white transition-colors">Herbs</Link></li>
            <li><Link to="/network" className="hover:text-white transition-colors">SocialPulse Network</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">Migration Admin</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-lg text-brand-sand">SocialPulse Network</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-brand-sand/70">
            {network.map((n) => (
              <li key={n} className="flex items-center gap-2">
                <span className="h-1 w-1 rounded-full bg-brand-clay" />
                {n}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-brand-sand/50">
        © {new Date().getFullYear()} Ayurvedam.com · Canonical owner of migrated Ayurveda content
      </div>
    </footer>
  );
}
